import { track, EventTypes, Product, getPageSource } from '@mc/track-event'
import { CheckoutEvents, BOGO_PROPS } from '../../lib/constants'

export const trackBogoSendGiftModalViewed = () =>
  track(EventTypes.MODAL_VIEWED, {
    modal_type: BOGO_PROPS.SHARE_MEMBERSHIP.MODAL_TYPE,
    page_source: CheckoutEvents.PAGES.CART_REGISTRATION,
    location: BOGO_PROPS.SHARE_MEMBERSHIP.LOCATION,
  })

export const trackBogoPromoModalViewed = () =>
  track(EventTypes.MODAL_VIEWED, {
    modal_type: BOGO_PROPS.PROMO_MODAL.MODAL_TYPE,
    page_source: getPageSource(),
    location: BOGO_PROPS.PROMO_MODAL.LOCATION,
    category: 'details',
    url_referrer: 'www.masterclass.com',
    product: Product.MASTERCLASS,
  })
